export const surveyConfig = [
  {
    name: 'reportCategories',
    displayName: 'Manage report categories',
    type: 'reportCategories',
    category: 'Reports',
  },
  {
    name: 'reportRecommendations',
    displayName: 'Recommendations creator',
    type: 'reportRecommendations',
    category: 'Reports',
  },
];
